import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { ChevronDown, ChevronRight } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { stylesRefs } from '../index.styles'
import '../index.styles.css'

const CoverageTitle = ({ isOpen = false }: { isOpen?: boolean }) => {
  const cx = useClassNames(stylesRefs)
  const title = i18n.t('shift_management.coverage_section.new_title')

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      width="full"
      height="full"
      paddingX="s8"
      style={{
        boxSizing: 'border-box',
        backdropFilter: 'blur(999px)',
      }}
      className={cx('header', 'sticky')}
    >
      <Box flexDirection="row" alignItems="center" width="full" height="full" gap="s4">
        <F0Icon icon={isOpen ? ChevronDown : ChevronRight} size="sm" />
        <Text size="200" weight="medium" className="text-f1-foreground">
          {title}
        </Text>
      </Box>
    </Box>
  )
}

export default CoverageTitle
